import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/serviceCallStyles/ServiceCard.css";

const ServiceCard = ({ card }) => {
  const navigate = useNavigate();
  const handleServiceCallClick = (id) => {
    navigate(`/servicedetails/${id}`);
  };
  
  return (
    <div className="card service-card">
      <div className="card-header">
        <span className="date-range">{card.dateRange}</span>
        <span className={`status ${card.status}`}>
          
          <img src={card.img} alt={card.status} className="status-icon" />
          {card.status.charAt(0) +
            card.status.slice(1).replace("-", " ")}
        </span>
      </div>

      <div className="card-body">
        <h3 className="address">{card.address}</h3>
        <p className="time">{card.time}</p>
        <span className="task-list">
          <li className="work">
            {card.work} -{" "}
            {card.subtasks.map((subtask, index) => (
              <span key={index}>
                {subtask.subtaskName}
                {index < card.subtasks.length - 1 ? ", " : ""}
              </span>
            ))}
          </li>
        </span>

        <div className="workers">
          <span className="worker-avatar">
            <img
              src="/images/users.svg"
              alt={card.workers}
              className="avatar-image"
            />
          </span>

          <p> {card.workers.join(", ")}</p>
        </div>

        <div className="card-footer">
          <button
            className="arrow-btn"
            onClick={() => handleServiceCallClick(card.serviceCallId)}
          >
            <img src="/images/arrow.png" alt="Arrow" className="arrow-icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
